module.exports = __webpack_public_path__ + "img/SK.776ea6b2.png";